/**
 * 站点导航唯一数据源：顶部菜单与面包屑均由此生成。
 * 子栏目通过 list 页 query.id 与后台栏目对应。
 */

function routerToLegacy(to) {
	if (!to || to === 'false') return to
	if (typeof to === 'string') return to
	const path = to.path || '/'
	const q = to.query
	if (q && Object.keys(q).length) {
		const params = new URLSearchParams()
		Object.keys(q).forEach((k) => params.set(k, String(q[k])))
		const s = params.toString()
		return { path: s ? `${path}?${s}` : path }
	}
	return { path }
}

export const RAW_NAV_MENU = [
	{ title: '首页', to: { path: '/' } },
	{
		title: '党建工作',
		list: [
			{ title: '党建头条', to: { path: '/foundparty/list', query: { id: '24' } } },
			{ title: '党建活动', to: { path: '/foundparty/list', query: { id: '25' } } },
			{ title: '组织结构', to: { path: '/foundparty/list', query: { id: '26' } } }
		]
	},
	{ title: '大数据平台', to: 'false' },
	{
		title: '标准与知识产权',
		list: [
			{ title: '政策宣贯', to: { path: '/foundparty/list', query: { id: '44' } } },
			{ title: '标准与认证', to: { path: '/news/list', query: { id: '2' } } },
			{ title: '知识产权', to: { path: '/news/list', query: { id: '3' } } }
		]
	},
	{
		title: '云上会展',
		list: [
			{ title: '云上看展', to: { path: '/exhibition/cloud', query: { id: '47' } } },
			{ title: '线下展览', to: { path: '/exhibition/offline', query: { type: '2' } } },
			{ title: '视频直播', to: { path: '/exhibition/live', query: { id: '48' } } },
			{ title: '企业展厅', to: { path: '/company/list' } }
		]
	},
	{
		title: '中试平台',
		list: [
			{ title: '政策宣贯', to: { path: '/foundparty/list', query: { id: '45' } } },
			{ title: '中试服务', to: { path: '/pilotplatform/list', query: { id: '35' } } },
			{ title: '实验室共享', to: 'false' }
		]
	},
	{
		title: '企业赋能',
		list: [
			{ title: '政策宣贯', to: { path: '/news/list', query: { id: '37' } } },
			{ title: '服务专项', to: { path: '/news/list', query: { id: '38' } } },
			{ title: '产业链对接', to: { path: '/news/list', query: { id: '19' } } },
			{ title: '产学研金用合作', to: { path: '/news/list', query: { id: '40' } } }
		]
	},
	{
		title: '培训研学',
		list: [
			{ title: '国内研学', to: { path: '/train/list', query: { id: '15' } } },
			{ title: '国外研学', to: { path: '/train/list', query: { id: '16' } } },
			{ title: '线上培训', to: { path: '/train/list', query: { id: '17' } } }
		]
	},
	{
		title: '协会活动',
		list: [
			{ title: '会展通知', to: { path: '/events/list', query: { id: '13' } } },
			{ title: '活动报名', to: { path: '/events/list', query: { id: '14' } } }
		]
	},
	{
		title: '科学普及',
		list: [
			{ title: '金属材料', to: { path: '/study/list', query: { id: '9' } } },
			{ title: '高分子材料', to: { path: '/study/list', query: { id: '10' } } },
			{ title: '无机非金属材料', to: { path: '/study/list', query: { id: '11' } } },
			{ title: '普及活动', to: { path: '/study/list', query: { id: '12' } } }
		]
	},
	{ title: '扶贫商城', to: 'false' },
	{
		title: '关于我们',
		list: [
			{ title: '协会简介', to: { path: '/aboutus/introduce', query: { id: '20' } } },
			{ title: '协会章程', to: { path: '/aboutus/introduce', query: { id: '21' } } },
			{ title: '组织架构', to: { path: '/aboutus/introduce', query: { id: '22' } } },
			{ title: '新材料产业分类名称', to: { path: '/aboutus/introduce', query: { id: '46' } } },
			{ title: '联系我们', to: { path: '/aboutus/introduce', query: { id: '23' } } },
			{ title: '表格下载', to: { path: '/aboutus/introduce', query: { id: '43' } } }
		]
	}
]

/** 与 headern 一致的菜单结构（to 为 router 可用的 path 串） */
export function getHeaderMenuList() {
	return RAW_NAV_MENU.map((section) => {
		const row = { title: section.title }
		if (section.to !== undefined) row.to = routerToLegacy(section.to)
		if (section.list) {
			row.junior = false
			row.list = section.list.map((sub) => ({
				title: sub.title,
				to: routerToLegacy(sub.to)
			}))
		}
		return row
	})
}
